import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";

import Login from "./Login";
import PrimaryNavigation from "./PrimaryNavigation";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Register from "./Register";
import { t } from "i18next";
import { toFixedWithoutRounding } from "../Utils/constants";

const HeaderComponent = () => {
  const [langOpen, setLangOpen] = useState(false);
  const [hideBalance, setHideBalance] = useState(false);
  const lang = useContextSelector(AuthContext, (ctx) => {
    return ctx.lang;
  });
  const handleModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.handleModalAccount;
  });
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh
  );
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const changeLanguage = useContextSelector(AuthContext, (ctx) => {
    return ctx.changeLanguage;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const accountModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.accountModal;
  });
  const setMenuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setMenuModal;
  });
  const setLoginModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const loginModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.loginModal;
  });
  const registerModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.registerModal;
  });
  const setRegisterModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setRegisterModal;
  });
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const previousAccountModal = useRef(accountModal);
  const openMemberTab = (type = "account") => {
    setShow(false);
    if (location.pathname === "/member") {
      handleModalAccount(type);
      const next = type === "account" ? "/member" : `/member?tab=${type}`;
      if (`${location.pathname}${location.search}` !== next) navigate(next);
      return;
    }
    navigate(type === "account" ? "/member" : `/member?tab=${type}`);
  };

  useEffect(() => {
    // A newly mounted header can briefly receive the previous page's open state.
    // Only a new account request should navigate away from the current page.
    if (previousAccountModal.current === accountModal) return;
    previousAccountModal.current = accountModal;
    if (!accountModal?.status || isEmpty(user)) return;
    if (location.pathname === "/member") return;
    const type = accountModal.type || "account";
    navigate(type === "account" ? "/member" : `/member?tab=${type}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountModal]);

  return (
    <div data-v-6577e1c3 className="header">
      <div data-v-6577e1c3 className="header_title">
        <div data-v-6577e1c3 className="header_top">
          <div className="wrapper">
            <div className="right-wrap">
              <img
                onClick={() => navigate("/")}
                src={"/assets/chorki/logo.svg"}
                alt="Logo"
                className="common-logo logo"
              />{" "}
              <PrimaryNavigation />
              {isEmpty(user) ? (
                <div className="hd_login">
                  <div className="header-login-wrap">
                    <div
                      onClick={() => setLoginModal(true)}
                      className="header-item login"
                    >
                      <span>{t("Login")}</span>
                    </div>{" "}
                    <div
                      onClick={() => setRegisterModal(true)}
                      className="header-item register"
                    >
                      <span>{t("Register")}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div data-v-4d48d98c className="logined_wrap">
                  <div className="ref-user-stack">
                    <div data-v-4d48d98c className="member-wrap">
                      <div
                        data-v-4d48d98c
                        className={`header-member-wrap${show ? " open" : ""}`}
                        tabIndex={0}
                        role="button"
                        aria-haspopup="menu"
                        aria-label="Open profile menu"
                        aria-expanded={show ? "true" : "false"}
                        onClick={() => setShow((value) => !value)}
                        onBlur={(event) => {
                          if (!event.currentTarget.parentElement?.contains(event.relatedTarget)) {
                            setShow(false);
                          }
                        }}
                      >
                        <img
                          data-v-4d48d98c
                          alt=""
                          className="avatar"
                          src={"/assets/Icon/0.webp"}
                        />
                        <span className="ref-member-label">
                          {user?.user?.username || user?.username || "Member"}
                          <em> (VIP0)</em>
                          <i className="ref-member-caret" aria-hidden="true" />
                        </span>
                      </div>
                      <div
                        data-v-4d48d98c
                        className={`drop-menu ref-profile-menu${show ? " open" : ""}`}
                        role="menu"
                      >
                        {[
                          ["account", "Profile"],
                          ["invite", "Invite Friends"],
                         
                          ["accountRecord", "Account Record"],
                          ["betting", "Betting Record"],
                        ].map(([type, label]) => (
                          <button
                            key={type}
                            type="button"
                            role="menuitem"
                            className="ref-profile-item"
                            onClick={() => openMemberTab(type)}
                          >
                            {label}
                          </button>
                        ))}
                        <button
                            
                            type="button"
                            role="menuitem"
                            className="ref-profile-item"
                            onClick={() => navigate("/member/withdraw")}
                          >
                            Withdraw
                          </button>
                        <button
                          type="button"
                          role="menuitem"
                          className="ref-profile-item logout"
                          onClick={() => {
                            setShow(false);
                            logoutUser();
                          }}
                        >
                          Logout
                        </button>
                      </div>
                    </div>
                    <div data-v-4d48d98c className="balance-wrap">
                      <span data-v-4d48d98c className="balance-amount">
                        {hideBalance
                          ? "****"
                          : Number(userCoins?.balance || 0).toFixed(2)}
                      </span>
                      <button
                        type="button"
                        className="balance-eye"
                        aria-label={hideBalance ? "Show balance" : "Hide balance"}
                        onClick={(event) => {
                          event.stopPropagation();
                          setHideBalance((value) => !value);
                          if (!hideBalance) return;
                          amounutRefresh?.();
                        }}
                      >
                        {hideBalance ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="ref-header-deposit"
                    // onClick={() => openMemberTab("deposit")}
                    onClick={() => navigate("member/deposit")}
                  >
                    {t("Deposit")}
                  </button>
                  <div data-v-4d48d98c className="event_wrap" />
                </div>
              )}
              <div className={`language_wrap${langOpen ? " open" : ""}`} onClick={() => setLangOpen((open) => !open)}>
                <div className="selected_lang">
                  <div className="flag-box">
                    <img
                      src={
                        lang == "en"
                          ? "/assets/bdtwin/flag-us.svg"
                          : "/assets/bdtwin/flag-bd.svg"
                      }
                      alt="EN"
                      loading="lazy"
                      className="flag-icon"
                    />
                  </div>{" "}
                  <span className="lang_name">
                    {lang == "en" ? "English" : "বাংলা"}
                  </span>{" "}
                  <ul className="option_list">
                    <li className={lang === "bn" ? "active" : undefined} onMouseDown={(e) => e.preventDefault()} onClick={() => changeLanguage("bn")}>
                      <img
                        src="/assets/bdtwin/flag-bd.svg"
                        alt=""
                        loading="lazy"
                        className="flag-icon"
                      />{" "}
                      <span>বাংলা</span>
                    </li>
                    <li className={lang === "en" ? "active" : undefined} onMouseDown={(e) => e.preventDefault()} onClick={() => changeLanguage("en")}>
                      <img
                        src="/assets/bdtwin/flag-us.svg"
                        alt=""
                        loading="lazy"
                        className="flag-icon"
                      />{" "}
                      <span>English</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        <span data-v-6577e1c3 className="separate-line" />
      </div>{" "}
      <div data-v-6577e1c3 className="header_holder" />
      {loginModal && <Login setLoginModal={setLoginModal} />}
      {registerModal && <Register setRegisterModal={setRegisterModal} />}
    </div>
  );
};

export default HeaderComponent;
